import React from "react";
import Przelewy24 from '../../../assets/svg/przelewy24.svg';
import FrameBlockResult from '../FrameBlockResult';
import { ApmsTypes } from "../../../constants";

const Przelewy24Result = ({ link }) => {
    return (
        <FrameBlockResult link={link} apmType={ApmsTypes.Przelewy24} icon={Przelewy24} />
    )
}

export default Przelewy24Result;